import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { UntypedFormGroup, UntypedFormControl} from '@angular/forms';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { SnackbarService } from 'src/app/_services/snackBar.service';
import { SnackBarErrorComponent } from 'src/app/components/snack-bar-error/snack-bar-error.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { DashboardService } from '../_services/dashboard.service';
import moment from 'moment';


declare var $: any;


@Component({
  selector: 'app-view-student',
  templateUrl: './view-student.component.html',
  styleUrls: ['./view-student.component.scss']
})
export class ViewStudentComponent implements OnInit {
  modalTitle: string = 'View Student';
  currLang;
  image;
  clazz;
  from: number;
  to: number;
  total: number;
  reportFilter;
  currentPage:number = 1;
  fieldsReadOnly: boolean = true;
  studentID: number;
  viewStudentForm: UntypedFormGroup;
  showedNumber: number;
  perpage:number = 3;
  loading:boolean = false;
  studentDismissal=[];
  studentDataSubscription;
  exportFilter;
  constructor(
    private snackbarService: SnackbarService,
    private _snackBar: MatSnackBar,
    private dataService: DataService,
    private globalService: GlobalService,
    private dashboardService: DashboardService,
    private translate: TranslateService,) { 
      this.studentDataSubscription = new Subscription();
      this.globalService.getLang().subscribe(lng => {
        this.currLang = lng;
        this.translate.use(this.currLang);
      });
    }

  ngOnInit(): void {
     // to remove the black screen and the stuck error msg popup if error message was just closed in sibling component 
     $('.modal').modal('hide');
     $('body').removeClass('modal-open');
     $('.modal-backdrop').remove();
     $(document).on('hidden.bs.modal', '#viewStudentModal', () => {
      this.closeModalHandler();
    });
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.dataService.getRowsNumberShown().subscribe(res => {
      this.showedNumber = res
    })
    this.viewStudentForm = new UntypedFormGroup({
      name: new UntypedFormControl(''),
      national_id: new UntypedFormControl(''),
      // gender: new FormControl(''),
      grade_id: new UntypedFormControl(''),
      class_id: new UntypedFormControl(''),
    })
    this.dashboardService.getReportFilter().subscribe(res=>{
      this.reportFilter = res;
    })
     // view student 
     let s = this.dashboardService.getStudentData().subscribe((res: any) => {
      this.studentDismissal = [];
      this.exportFilter = null;
      if (res !== null) {
        this.exportFilter = res.student.filter;
        this.clazz = res.student.class;
        this.modalTitle = res.student.name;
        this.studentID = res.student.id;
        this.image = environment.img_url + res.student.image_path;
        this.from = res.student.dismissalHistory.from;
        this.to = res.student.dismissalHistory.to;
        this.total =res.student.dismissalHistory.total;
        for (const i in this.viewStudentForm.value) {
          this.viewStudentForm.controls[i].setValue(res.student[i]);
        }
        this.viewStudentForm.controls.grade_id.setValue(res.student.class.grade.name);
        this.viewStudentForm.controls.class_id.setValue(res.student.class.name);
        if(res.student.dismissalHistory.data.length!=0){
        this.studentDismissal = res.student.dismissalHistory.data
        }
      }
    })
    this.studentDataSubscription.add(s);
  }

  // display-only: the raw backend role value is not modified
  getRoleLabel(role: string): string {
    if (!role) { return role; }
    const key = `roles.${role}`;
    const translated = this.translate.instant(key);
    return translated !== key ? translated : role;
  }

  getTime(dateTime){
    let time;
     if(dateTime !=null){
    time = moment(new Date(dateTime)).subtract(3,'h').add(localStorage.getItem('timeZoneOffset'),'h').locale(this.currLang).format('hh:mm A');
     }
    return time;
  }
  getDate(dateTime){
    let date;
    if(dateTime){
    date = moment(new Date(dateTime)).locale(this.currLang).format('DD-MM-YYYY');
    }
    return date;
  }
  closeModalHandler(){
    // this.dataService.setRowsNumberShown(this.showedNumber);
    // this.fieldsReadOnly = false;
    this.image = null;
    this.modalTitle = '';
    // this.addStudentForm.reset();
    // this.addParentForm.reset();
    this.from = this.to = this.total = 0 ;
    this.currentPage = 1;
    $("#viewStudentModal").modal("hide");
  }

  getData(){
    this.loading = true;
    this.dashboardService.getStudentDismissalById(this.studentID,this.reportFilter,this.currentPage,4).subscribe((res:any)=>{
      this.studentDismissal = [];
      this.to = res.to;
      this.from = res.from;
      this.total = res.total;
      if(res.data.length!=0){
      this.studentDismissal = res.data
      }
    },err=>{},()=>{
      this.loading = false;
    })
    
  }
  paginationChange(direction) {
    if ((direction == 1 && this.to != this.total) || (direction == -1 && this.from != 1)) {
      this.currentPage += direction;
      this.getData();      
    }
  }

  generateExcelFile(){
    this.globalService.setExportAlert('preparing');
    this.dashboardService.generateExcelFileById(this.studentID,this.exportFilter).subscribe(res=>{
      
    })
  }
}
